const toolInputTypes = {
  URL: "url",
  ISO: "iso",
  DATASHEET: "datasheet",
  MANUAL: "manual",
};

export default toolInputTypes;
